var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_6647_37082)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 19.125V4.875H13.5C14.8125 4.875 16.875 6.375 16.875 8.8125C16.875 10.0125 16.125 11.0625 15.75 11.4375C16.5 11.6875 18 12.75 18 15C18 17.25 16 18.6875 15 19.125H7.5ZM12.6857 13.125H13.125V16.875H12.6857C12.4867 16.875 12.296 16.796 12.1553 16.6553L11.0303 15.5303C10.7374 15.2374 10.7374 14.7626 11.0303 14.4697L12.1553 13.3447C12.296 13.204 12.4867 13.125 12.6857 13.125ZM10.875 7.125H11.3143C11.5133 7.125 11.704 7.20402 11.8447 7.34467L12.9697 8.46967C13.2626 8.76256 13.2626 9.23744 12.9697 9.53033L11.8447 10.6553C11.704 10.796 11.5133 10.875 11.3143 10.875H10.875V7.125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6647_37082",
    x1: 0,
    y1: 0,
    x2: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0926016,
    stopColor: "#6844FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919873,
    stopColor: "#FCAD94"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBob);
export default __webpack_public_path__ + "static/media/bob.f42a25cad67a6036ff71ed96d466581c.svg";
export { ForwardRef as ReactComponent };